module.exports = __webpack_public_path__ + "3c56671c595d4236cbeb93784cfad712.pdf";